import { useState } from 'react';

import type { AuditEvent, Tenant } from '../domain-types';

export function usePlatform() {
  const [auditEvents, setAuditEvents] = useState<AuditEvent[]>([]);
  const [platformTenants, setPlatformTenants] = useState<Tenant[]>([]);
  const [newTenantName, setNewTenantName] = useState('');
  const [newTenantSlug, setNewTenantSlug] = useState('');
  const [newTenantAdministratorEmail, setNewTenantAdministratorEmail] = useState('');
  const [tenantLifecycleBusy, setTenantLifecycleBusy] = useState(false);
  const [qualityReportBusy, setQualityReportBusy] = useState(false);
  return {
    auditEvents,
    setAuditEvents,
    platformTenants,
    setPlatformTenants,
    newTenantName,
    setNewTenantName,
    newTenantSlug,
    setNewTenantSlug,
    newTenantAdministratorEmail,
    setNewTenantAdministratorEmail,
    tenantLifecycleBusy,
    setTenantLifecycleBusy,
    qualityReportBusy,
    setQualityReportBusy,
  };
}
